import React, { Component } from 'react'
import {Carousel, Button, Modal } from 'react-bootstrap'
import Spinner from '../../../../Spinner'

export default class SliderNeighborhood extends Component {

	render () {

    const { 
      neighborhood
    } = this.props;

    var next = <i className="fa fa-angle-right fa-3x"></i>;
  	var prev = <i className="fa fa-angle-left fa-3x"></i>; 

  	let images = neighborhood[0].images   

    return(
      <div>
        <Carousel indicators={false} nextIcon={next} prevIcon={prev}>
          {images.map((item, index) => 
            <Carousel.Item key={item}>
              <img className="img-back" src={item}/>
            </Carousel.Item>
          )}             
        </Carousel>
      </div>
    )
   }
}


// WEBPACK FOOTER //
// ./src/components/Sections/Propiedades/Detail/Slider/sliderNeighborhood.js